import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../firebase-client';
import CourseBoatReservations from './CourseBoatReservations';

const getPlan = httpsCallable(functions, 'getCourseAssetPlan');
const savePlan = httpsCallable(functions, 'saveCourseAssetPlan');

export default function EditCourseBoatReservations({ teamId, courseType, courseId, onClose }) {
  const [plan, setPlan] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() => {
    let active = true;
    getPlan({ teamId, courseType, courseId }).then((result) => {
      if (active) setPlan(result.data?.plan || null);
    }).catch((err) => active && setError(err?.message || 'Could not load course reservations.'));
    return () => { active = false; };
  }, [courseId, courseType, teamId]);

  const patchSession = (sessionId, assetReservations) => setPlan((current) => ({
    ...current,
    sessions: (current.sessions || []).map((session) => session.id === sessionId ? { ...session, reservations: assetReservations } : session),
  }));
  const handleSave = async () => {
    setSaving(true); setError(''); setMessage('');
    try {
      const result = await savePlan({
        teamId, courseType, courseId, courseName: plan.courseName, state: plan.state,
        sessions: (plan.sessions || []).map((session) => ({ ...session, assetReservations: session.reservations || [] })),
      });
      setPlan(result.data?.plan || plan);
      setMessage('Course boat reservations saved.');
    } catch (err) {
      setError(err?.message || 'Could not save course reservations.');
    } finally { setSaving(false); }
  };

  return <div className="form-container">
    <div className="modal-header"><h2>Course boat reservations</h2><button type="button" onClick={onClose} aria-label="Close">×</button></div>
    {error && <p className="text-danger" role="alert">{error}</p>}
    {message && <p className="text-success" role="status">{message}</p>}
    {!plan && !error && <p className="text-muted">Loading reservations…</p>}
    {plan && <>
      <h3>{plan.courseName || 'Course'}</h3>
      {(plan.sessions || []).map((session, index) => <section className="card" key={session.id} style={{ padding: 12, marginBottom: 12 }}>
        <strong>{session.name || `Session ${index + 1}`}</strong>
        <CourseBoatReservations
          teamId={teamId}
          courseType={courseType}
          session={{ ...session, assetReservations: session.reservations || [] }}
          onChange={(assetReservations) => patchSession(session.id, assetReservations)}
        />
      </section>)}
      <div className="form-actions"><button type="button" className="button button-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving…' : 'Save reservations'}</button><button type="button" className="button button-secondary" onClick={onClose}>Close</button></div>
    </>}
  </div>;
}
